
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  onBeforeUnmount
} from "vue";
import { useRouter } from "vue-router";
import { useAuth, TURNSTILE_VERIFIED } from "../../modules/auth";
import { CredencialPayload } from "../../modules/business/common/commonBusiness";

declare global {
  interface Window {
    turnstile?: {
      render: (
        element: HTMLElement,
        options: Record<string, unknown>
      ) => string;
      reset: (widgetId: string) => void;
      remove: (widgetId: string) => void;
    };
  }
}

interface LoginState {
  credenciais: CredencialPayload;
  loading: boolean;
}

export default defineComponent({
  setup() {
    const router = useRouter();
    const turnstileRef = ref<HTMLElement>();
    const turnstileToken = ref<string | null>(null);
    let widgetId: string | undefined;

    const state = reactive<LoginState>({
      credenciais: {},
      loading: false
    });

    const renderTurnstile = () => {
      if (window.turnstile && turnstileRef.value) {
        widgetId = window.turnstile.render(turnstileRef.value, {
          sitekey: "0x4AAAAAAC21H5ax1d8XlZhC",
          callback: (token: string) => {
            turnstileToken.value = token;
          },
          "expired-callback": () => {
            turnstileToken.value = null;
          },
          "error-callback": () => {
            turnstileToken.value = null;
          }
        });
      }
    };

    onMounted(() => {
      const interval = setInterval(() => {
        if (window.turnstile?.render) {
          clearInterval(interval);
          renderTurnstile();
        }
      }, 200);
      setTimeout(() => clearInterval(interval), 10000);
    });

    onBeforeUnmount(() => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    });

    const submit = () => {
      if (!turnstileToken.value) return;
      state.loading = true;
      state.credenciais.turnstileToken = turnstileToken.value;
      useAuth()
        .login(state.credenciais)
        .then(() => {
          sessionStorage.setItem(TURNSTILE_VERIFIED, "true");
          return router.push({ name: "home" });
        })
        .then(() => {
          state.loading = false;
        })
        .catch(() => {
          state.loading = false;
          if (widgetId && window.turnstile) {
            window.turnstile.reset(widgetId);
            turnstileToken.value = null;
          }
        });
    };
    return {
      submit,
      turnstileRef,
      turnstileToken,
      ...toRefs(state)
    };
  },
  components: {}
});
